"use strict";
"use client";
import { findSupportedLocale } from "../../util/i18n.js";
import { useLocale } from "../useLocale/useLocale.js";
function useI18n(props, translations) {
  const locale = useLocale(props.locale);
  const supportedLocale = findSupportedLocale(locale);
  const strings = translations[supportedLocale] || {};
  const keys = Object.keys(strings);
  const translatedProps = keys.reduce(
    (acc, key) => {
      acc[key] = props[key] || strings[key];
      return acc;
    },
    {}
  );
  return { ...props, ...translatedProps, locale };
}
export {
  useI18n
};
